import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-animated-error',
  templateUrl: './animated-error.component.html',
  styleUrls: ['./animated-error.component.scss']
})
export class AnimatedErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
